enum ProductType {
  NUMBER_LIMIT = 'NUMBER_LIMIT',
  TIME = 'TIME',
  TIME_AND_NUMBER  = 'TIME_AND_NUMBER',
}

export default ProductType;
